import { type Component } from 'solid-js'

const WebinarHeadline: Component = () => {
  return (
    <div class="w-full flex flex-col gap-4 items-center justify-center text-center text-white">
      <span class="text-white font-bold font-poppins text-3xl sm:text-4xl xl:text-5xl leading-tight xl:leading-[56px]">
        Get ProfitTree Pro
        <br />+ 1 Year of Unlimited Rupert AI
      </span>
      <span class="text-maize-400 font-bold font-poppins text-base sm:text-xl">
        🔥 ProfitTree Pro Webinar Exclusive Offer
      </span>
    </div>
  )
}

export default WebinarHeadline
